import React from 'react';
import styles from './smart-records-panel.module.css';
import { capitalize } from 'lodash';

const SectionTitle: React.FC<{ title: string }> = ({ title }) => {
  return <div className={styles.sectionTitle}>{capitalize(title)}</div>;
};

export default SectionTitle;
